<template>
<div>
    <div
        style="text-align: center; margin-top: 30px; margin-bottom: 30px"
        v-if="results.length == 0 && show_help_when_no_payment_methods"
    >
        <p>You do not have any payment methods on file.</p>  
        <p>We are still adding payment methods on file before December 9th.  If you have a payment method on file with RedChirp and don't see it here, give us a few days to get everything linked up</p>
    </div>

    <div
        v-else
    >
       <m-redchirp-payment-method
            v-for="(item, index) in results"
            :key="index"
            :value="item"
            style="margin-bottom: 15px;"
            v-on:update="update"
       />

    </div>

    <div
        style="text-align: right"
    >
        <v-btn
            color="primary"
            v-on:click="onClickAddPaymentMethod"
        >
            Add Payment Method...
        </v-btn>
    </div>
</div>
</template>

<script>
export default {
    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },

        show_help_when_no_payment_methods: {
            type: Boolean,
            default: function() { return true; }
        },
    },

    data() {
        return {
            results: [],
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/organizations/red-chirp-payments',
            
                'params' : {
                        'organization_id': this.organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list your payment methods',
            });
        },

        onClickAddPaymentMethod()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/organizations/red-chirp-payments/start-add-stripe',
            
                'params' : {
                        'after_url': ''+window.location,
                        'organization_id': this.organization_id,
                    },
            
                'on_success': (data) => {
                        window.location = data.url;
                    },
            
                'on_error': 'Unable to add payment method.',
            });
        },


    },
}
</script>

<style lang="scss" scoped>

</style>